<template>
  <section class="story-testimonial">
    <div class="story-testimonial__content">
      <div class="story-testimonial__images">
        <div class="story-testimonial__img-container">
          <img id="st" src="../assets/story-testimonial/img-1.jpeg" />
        </div>
      </div>
      <div class="story-testimonial__text">
        <p>“We had been looking at the cannabis space for a few years,
          trying to determine our best entrance that would mitigate
          the high risk. <b>We knew that by partnering with a solid
          franchisor we wouldn’t have to go through the School of
          Hard Knocks and dug into cannabis franchises.</b>
          <br><br>
          We found a few that were just selling a business plan,
          no long-term support, and then discovered Unity Rd.
          <b>The team has a depth of history on both the retail and
          cultivation side with awards to back them up. We felt
          most comfortable with Unity Rd. versus other routes
          into this nascent industry.”</b>
        </p>
        <h3>- BRUCE AND NATE WETZEL</h3>
        <h2>UNITY RD. FRANCHISE PARTNERS FATHER-AND-SON-TEAM </h2>

      </div>
      <div class="story-testimonial__images">
        <div class="story-testimonial__img-container">
          <img src="../assets/story-testimonial/img-2.png" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StoryTestimonial",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/StoryTestimonial.scss";
</style>
